'use client'

import { useTranslations } from 'next-intl'

import { cn, numberUnit } from '@/lib/utils'
import { CategoryProductDetail } from '@/types/home.type'
import { Product, ProductFullSearchData } from '@/types/product.type'

import Icon from '../ui/icon'
import ShowUnit from '../ui/ShowUnit'
import Tooltips from '../ui/Tooltips'

type ProductInventoryProps = {
  product: Product | CategoryProductDetail | ProductFullSearchData
  className?: string
  showUnit?: boolean
  fontSize?: string
}

export default function ProductInventory({ product, className, showUnit = false, fontSize }: ProductInventoryProps) {
  const t = useTranslations('common')
  const tOrder = useTranslations('my_order')
  return (
    <div
      className={cn('text-[13px] px-1 py-1 mt-2 flex justify-between text-center', className, {
        'bg-aqua text-[#008000]': product.inventory > 0,
        'bg-warning !text-red-600': product.inventory <= 0,
      })}
    >
      <div className="flex items-center gap-1 text-sm">
        <Icon icon={product.inventory > 0 ? 'tgic icon-check' : 'tgic icon-info-solid'} style={{ WebkitTextStroke: product.inventory > 0 ? '1px #008000' : '' }} />
        {product.inventory > 0 && (
          <span className={cn('text-[13px]', fontSize)}>
            {t('in_stock')}: {numberUnit(product.inventory)} {showUnit && <ShowUnit unit={product.unit} />}
          </span>
        )}
        {product.inventory <= 0 && <span className={cn('text-[13px]', fontSize)}>{t('out_of_stock')}</span>}
      </div>
      <div className="relative inline-flex items-center group cursor-pointer">
        <div className={cn('h-4 w-4 flex items-center justify-center p-1 rounded-full border', { 'border-[#008000]': product.inventory > 0, 'border-red-600': product.inventory <= 0 })}>
          𝒊
        </div>
        <Tooltips placement="left" className='z-[99] font-normal' style="warning" message={product.inventory > 0 ? t('instock_message') : t('outstock_message')} />
      </div>
    </div>
  )
}
